import { getConfig } from '@superbet-group/web.lib.config';
import { isEmpty as _isEmpty } from 'lodash';
import {
    AuthenticationError,
    RegistrationRequestIdError,
    ValidationError,
} from '@superbet-group/web.lib.utilities';
import nationalities from '@accountCountries/registration/nationalities';
import * as NetworkUtils from '@utils/network/networkHelpers';
import RegisterInput from '@countryModels/authentication/RegisterInput';

import {
    Nationality,
    RegisterResponse,
} from './Types';
import { currentSite } from '@src/app/utils/domainHelpers';
import { Site } from '@superbet-group/web.types';

export function checkIfResident(data: { nationality: string | null }): boolean {
    if (!data.nationality) {
        // For Romania we set this value to true because LeapBit is not providing us with
        // this information for Romania. I think it would be overkill to split this method
        // into 2 parts because we might need this if some bussiness logic changes
        return true;
    }

    const nationality: Nationality | undefined = (nationalities as Nationality[])
        .find((n) => n.name === data.nationality);

    return (nationality && nationality.code) === getConfig().countrySpecific.auth.countryId;
}

export function handleOnRegistrationError(response: RegisterResponse, registerInput: RegisterInput, setFieldErrorIfExist: (name: string, fieldErrors: any) => void) {
    if (response.fieldErrors?.cnp) {
        throw new AuthenticationError('cnp');
    } else if (!_isEmpty(response.fieldErrors)) {
        const fieldErrors = {};

        Object.keys(registerInput).forEach((key: string) => {
            setFieldErrorIfExist(key, fieldErrors);
        });

        throw new ValidationError(fieldErrors);
    } else if (response.errorCode === 'CouponNotFound') {
        const fieldErrors: any = {};
        fieldErrors.couponCode = [response.notice];
        throw new ValidationError(fieldErrors);
    } else if (response.notice) {
        const fieldErrors: any = {};
        fieldErrors.general = [response.notice];
        throw new ValidationError(fieldErrors);
    } else if (response.errors[0].code === 9000) {
        throw new ValidationError({ serPro: ['9000'] });
    } else if (response.request_id) {
        throw new RegistrationRequestIdError(response.request_id, response.errorCode);
    } else if (response.errorCode) {
        throw new Error(response.errorCode);
    } else {
        throw NetworkUtils.getRequestError(response);
    }
}

// Temp method to handle PL migration to Betler
export function getRegisterUrl(): string {
    if (currentSite === Site.SuperbetBetlerPl) {
        return 'register';
    }
    return getConfig().countrySpecific.auth.registerUrl;
}
